import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Titulo from '@components/Titulo';
import Boton from '@components/Boton';
import Resumen from '@components/Resumen';
import Advertencia from '@components/Advertencia';

import { cajaPrincipalStyle } from '@styles/cajaPrincipal';
import { cajaContenedorStyle } from '@styles/cajaContenedor';
import { cajaContenedorPrimeroStyle } from '@styles/cajaContenedorPrimero';
import { colors } from '@styles/colors';

import { verSedesApi } from "@api/wp/agenda/sedes/sedesApi"
import { viewSedePorOidEmpresaApi } from "@api/wp/sedes/sedesApi";
import { viewServicioPorSkuEmpresaApi } from "@api/wp/servicios/serviciosApi";
import { validateSsoApi } from "@api/wp/users/userApi";
import LoadingOverlay from '@components/LoadingOverlay';
import ServicioNoDisponible from '@components/ServicioNoDisponible';
import { useCita } from '@providers/citaContext';
import { activateLocalSsoSession, MEMBERSHIP_URL } from '@utils/const';

function Ubicacion() {
  const location = useLocation();
  const navigate = useNavigate();
  const { cita, setCita } = useCita();
  // Parámetros vía URL (query string)
  const searchParams = new URLSearchParams(location.search || '');
  const url_id = searchParams.get('id') || '';
  const url_t = searchParams.get('t') || '';
  const url_sku = searchParams.get('sku') || '';
  const url_nombre = searchParams.get('nombre') || '';
  const url_pa_departamentos = searchParams.get('pa_departamentos') || '';
  const url_pa_modalidad = searchParams.get('pa_modalidad') || '';

  // Parámetros vía state navigate
  const [ciudadIdSku, setCiudadIdSku] = useState(undefined);
  const ciudadId = ciudadIdSku ?? cita?.ciudadId ?? location.state?.ciudadId;

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

    const mapDepartamentoParam = (param) => {
    if (!param) return param;
    const p = String(param).toLowerCase();
    if (p === 'norte_santander' || p === 'norte-de-santander') return 'Norte de santander';
    return param;
  };
  const ciudadNombreRaw = (url_sku && url_sku.trim().length > 0 && url_pa_departamentos && url_pa_departamentos.trim().length > 0)
    ? url_pa_departamentos
    : (cita?.ciudadNombre ?? location.state?.ciudadNombre);
  const ciudadNombre = mapDepartamentoParam(ciudadNombreRaw);
  
  const [especialidadNombreSku, setEspecialidadNombreSku] = useState("");
  const especialidadNombre = (typeof especialidadNombreSku === 'string' && especialidadNombreSku.trim().length > 0)
    ? especialidadNombreSku
    : (cita?.especialidadNombre ?? location.state?.especialidadNombre);
  const [empresaNombreSku, setEmpresaNombreSku] = useState("");
  const empresaNombre = (typeof empresaNombreSku === 'string' && empresaNombreSku.trim().length > 0)
    ? empresaNombreSku
    : (cita?.empresaArray ?? location.state?.empresaNombre);
  const [oidEspecialidadSku, setOidEspecialidadSku] = useState("");
  const oidEspecialidad = (String(oidEspecialidadSku).trim().length > 0)
    ? Number(oidEspecialidadSku)
    : (cita?.oidEspecialidad ?? location.state?.oidEspecialidad);
  const [valorPreviplanSku, setValorPreviplanSku] = useState(undefined);
  const valorPreviplan = valorPreviplanSku ?? (cita?.valorPreviplan ?? location.state?.valorPreviplan);
  // Prioriza `url_sku` si viene en la URL; caso contrario, usa el estado
  const sku = (url_sku && url_sku.trim().length > 0) ? url_sku : (cita?.sku ?? location.state?.sku);
  const [nombreServicioSku, setNombreServicioSku] = useState("");
  const nombreServicio = (typeof nombreServicioSku === 'string' && nombreServicioSku.trim().length > 0)
    ? nombreServicioSku
    : (cita?.nombreServicio ?? location.state?.nombreServicio);
  const descripcion = (cita?.descripcion ?? location.state?.descripcion) || '';

  useEffect(() => {
    let cancelled = false;
    let redirectTimeout = null;

    const validarAcceso = async () => {
      setValidandoAcceso(true);
      setCargando(true);
      setErrorSedes('');

      const redirigirMembresiaConMensaje = (mensaje) => {
        setAccesoValidado(false);
        setValidandoAcceso(false);
        setCargando(false);
        setErrorSedes(mensaje);
        setSedes([]);
        setVerBusqueda(1);
        redirectTimeout = window.setTimeout(() => {
          window.location.href = MEMBERSHIP_URL;
        }, 1800);
      };

      if (url_t && url_t.trim().length > 0) {
        try {
          const response = await validateSsoApi({ t: url_t });
          const result = response?.result || response;

          if (cancelled) {
            return;
          }

          if (result?.success === true) {
            const userId = String(result?.user_id || '');
            if (userId) {
              activateLocalSsoSession(userId, url_t);
            }
            setAccesoValidado(true);
            setValidandoAcceso(false);
            setCargando(false);
            return;
          }

          redirigirMembresiaConMensaje(result?.message || 'Token inválido o expirado.');
          return;
        } catch (error) {
          if (cancelled) {
            return;
          }

          redirigirMembresiaConMensaje('No fue posible validar el acceso SSO.');
          return;
        }
      }

      const idUsu = localStorage.getItem('idUsu');
      if (!idUsu || idUsu === '0') {
        setAccesoValidado(false);
        setValidandoAcceso(false);
        setCargando(false);
        window.location.href = MEMBERSHIP_URL;
        return;
      }

      setAccesoValidado(true);
      setValidandoAcceso(false);
      setCargando(false);
    };

    validarAcceso();

    return () => {
      cancelled = true;
      if (redirectTimeout) {
        window.clearTimeout(redirectTimeout);
      }
    };
  }, [location.search]);

  // Parámetros adicionales opcionales
  const hasState = !!location.state && typeof location.state === 'object';
  const departamentoParam = hasState && ('departamento' in location.state) ? location.state.departamento : undefined;
  const idParam = hasState && ('id' in location.state) ? location.state.id : undefined;

  // Redirigir a selección de ciudades si viene SKU y pa_departamentos es 'None' o vacío
  useEffect(() => {
    if (!accesoValidado) {
      return;
    }
    const hasSku = url_sku && url_sku.trim().length > 0;
    const deptIsNone = url_pa_departamentos && url_pa_departamentos.trim().toLowerCase() === 'none';
    const deptIsEmpty = !url_pa_departamentos || url_pa_departamentos.trim().length === 0;
    if (hasSku && (deptIsNone || deptIsEmpty)) {
      navigate('/home');
    }
  }, [url_sku, url_pa_departamentos, navigate]);

  const [sedes, setSedes] = useState([]);
  const [cargandoSedes, setCargandoSedes] = useState(false);
  const [cargando, setCargando] = useState(false);
  const [errorSedes, setErrorSedes] = useState('');
  const [verBusqueda, setVerBusqueda] = useState(0);
  const [sedeSeleccionada, setSedeSeleccionada] = useState(null);
  const [sedeId, setSedeId] = useState(null);
  const [sedeNombre, setSedeNombre] = useState(null);
  const [empresaSeleccionada, setEmpresaSeleccionada] = useState(null);
  const [servicioNoDisponible, setServicioNoDisponible] = useState(false);
  const [advertenciaMensaje, setAdvertenciaMensaje] = useState('');
  const [accesoValidado, setAccesoValidado] = useState(false);
  const [validandoAcceso, setValidandoAcceso] = useState(true);

  // Helper para serializar empresas en una cadena separada por comas
  const toEmpresaCsv = (value) => {
    if (!value) return '';
    if (typeof value === 'string') return value;
    if (Array.isArray(value)) {
      return value
        .map((item) => {
          if (typeof item === 'string') return item.trim();
          if (item && typeof item === 'object') return (item.nombre_empresa || '').toString().trim();
          return '';
        })
        .filter(Boolean)
        .join(', ');
    }
    if (typeof value === 'object') {
      if (Array.isArray(value.empresas)) return toEmpresaCsv(value.empresas);
      if (typeof value.nombre_empresa === 'string') return value.nombre_empresa;
      return '';
    }
    return '';
  };

  useEffect(() => {
    if (!accesoValidado) {
      return;
    }
    console.log('Ciudad ID:', ciudadId);
    console.log('Ciudad Nombre:', ciudadNombre);
    console.log('OID VALOR SELCC:', valorPreviplan);
    console.log('OID Especialidad:', oidEspecialidad);
    console.log('Empresa Nombre:', empresaNombre);
    if (departamentoParam !== undefined) {
      console.log('departamento:', departamentoParam);
    }
    if (idParam !== undefined) {
      console.log('id:', idParam);
    }
    if (sku !== undefined) {
      console.log('sku:', sku);
    }
    // Evitar llamadas si faltan parámetros clave
    const hasDept = typeof ciudadNombre === 'string' && ciudadNombre.trim().length > 0;
    const hasEsp = typeof oidEspecialidad === 'number' && !Number.isNaN(oidEspecialidad);
    if (!hasDept || !hasEsp) {
      console.warn('Sedes: faltan parámetros clave para consultar (ciudadNombre u oidEspecialidad).');
      setCargandoSedes(false);
      return;
    }
    buscarSedesPorEspecialidadesDispo();
  }, [accesoValidado, ciudadNombre, ciudadId, oidEspecialidad, empresaNombre, sku]);

  // Consumir servicios por SKU/empresa cuando url_sku > 0
  useEffect(() => {
    if (!accesoValidado) {
      return;
    }
    if (url_sku && url_sku.length > 0) {
      (async () => {
        try {
          let result = [];
          if (url_pa_departamentos == 'atlantico') {
            // Primero intentamos con 'promocosta'
            let json = await viewServicioPorSkuEmpresaApi({ sku: url_sku, empresa: 'promocosta' });
            result = json?.result || json;
            // Si no hay resultados, intentamos con 'salud-social'
            if (!Array.isArray(result) || result.length === 0) {
              json = await viewServicioPorSkuEmpresaApi({ sku: url_sku, empresa: 'salud-social' });
              result = json?.result || json;
            }
            console.log('RESU SERVCIOS SKUP', result)
          } else {
            var empresaUrl = ''
            if (url_pa_departamentos == 'norte_santander') {
              empresaUrl = 'promonorte';
            }
            if (url_pa_departamentos == 'cesar') {
              empresaUrl = 'calidad-medica';
            }
            // Lógica estándar para otros departamentos o si no hay match específico
            const json = await viewServicioPorSkuEmpresaApi({ sku: url_sku, empresa: empresaUrl });
            result = json?.result || json;
          }
          const nombreFromApi = Array.isArray(result) && result.length > 0
            ? (result[0]?.nombre_servicio || '')
            : '';
          const especialidadFromApi = Array.isArray(result) && result.length > 0
            ? (result[0]?.nombre_especialidad || '')
            : '';
          const empresaFromApi = Array.isArray(result) && result.length > 0
            ? (result[0]?.nombre_empresa || '')
            : '';
          const oidEspFromApi = Array.isArray(result) && result.length > 0
            ? (result[0]?.idEsp ?? result[0]?.oid_especialidad ?? '')
            : '';
          const valorPreviplanFromApi = Array.isArray(result) && result.length > 0
            ? (result[0]?.valorPreviplan ?? null)
            : null;
          const valorParticularFromApi = Array.isArray(result) && result.length > 0
            ? (result[0]?.valorParticular ?? result[0]?.valor_particular ?? null)
            : null;
          const ciudadIdFromApi = Array.isArray(result) && result.length > 0
            ? (result[0]?.id_zon ?? null)
            : null;

          setNombreServicioSku(nombreFromApi);
          setEspecialidadNombreSku(especialidadFromApi);
          setOidEspecialidadSku(oidEspFromApi);
          setEmpresaNombreSku(empresaFromApi);
          const levelMem = localStorage.getItem('levelMem');
          console.log( 'LEVE ADMIN ', levelMem )
          const valorElegido = levelMem == '10' ? (valorParticularFromApi ?? valorPreviplanFromApi) : valorPreviplanFromApi;
          console.log( 'VALOR ', valorElegido )
          setValorPreviplanSku(valorElegido);
          setCiudadIdSku(ciudadIdFromApi);
          console.log('Servicios por SKU/empresa:', result);
        } catch (e) {
          console.error('Error consultando servicios por SKU/empresa:', e);
        }
      })();
    }
  }, [accesoValidado, url_sku]);

  // Construir y llenar el contexto desde parámetros de URL si existen.
  // Si no hay parámetros y el contexto está vacío, redirigir a home.
  useEffect(() => {
    if (!accesoValidado) {
      return;
    }
    const hasParams = Boolean(url_id || url_sku || url_nombre || url_pa_departamentos || url_pa_modalidad);

    if (hasParams) {
      const nextCita = {};
      if (ciudadIdSku !== undefined && ciudadIdSku !== null) nextCita.ciudadId = ciudadIdSku;
      if (url_pa_departamentos && url_pa_departamentos.trim().length > 0) nextCita.ciudadNombre = url_pa_departamentos;
      if (especialidadNombreSku && especialidadNombreSku.trim().length > 0) nextCita.especialidadNombre = especialidadNombreSku;
      if (nombreServicioSku && nombreServicioSku.trim().length > 0) nextCita.nombreServicio = nombreServicioSku;
      if (empresaNombreSku && empresaNombreSku.trim().length > 0) nextCita.empresaArray = empresaNombreSku;
      if (String(oidEspecialidadSku).trim().length > 0) nextCita.oidEspecialidad = Number(oidEspecialidadSku);
      if (valorPreviplanSku !== undefined && valorPreviplanSku !== null) nextCita.valorPreviplan = valorPreviplanSku;
      if (url_sku && url_sku.trim().length > 0) nextCita.sku = url_sku;

      if (Object.keys(nextCita).length > 0) {
        setCita(prev => ({ ...prev, ...nextCita }));
      }
    } else {
      const citaVacia = !cita || (typeof cita === 'object' && Object.keys(cita).length === 0);
      if (citaVacia) {
        navigate('/home');
      }
    }
  }, [accesoValidado, url_id, url_sku, url_nombre, url_pa_departamentos, url_pa_modalidad, nombreServicioSku, especialidadNombreSku, empresaNombreSku, oidEspecialidadSku, valorPreviplanSku, ciudadIdSku, navigate]);

  // Buscar disponibilidad de sedes por especialidad 
  const buscarSedesPorEspecialidadesDispo = async () => {
    setErrorSedes('');
    setVerBusqueda(0);
    setAdvertenciaMensaje('');
    setCargandoSedes(true);
    setServicioNoDisponible(false);
    try {
      const request = {
        departamento: ciudadNombre,
        oid_especialidad: oidEspecialidad,
      };
      console.log('Consultando sedes con request:', request);
      const response = await verSedesApi(request);
      console.log('Response ETE:', response);

      // Manejo específico para cuando no hay sedes disponibles (code 204)
      if (response && response.code === 204 && response.message === "No hay sedes con disponibilidad futura para la especialidad indicada") {
        setSedes([]);
        setAdvertenciaMensaje(response.message);
        setVerBusqueda(1);
        setCargandoSedes(false);
        return;
      }

      // Agregar las sedes al array total, uniendo con sedesLocales por oid para incluir la dirección
      if (response.data && response.data.length > 0) {
        buscarSedesDireccion(response.data)
      } else {
        setSedes([]);
        setCargandoSedes(false);
      }

    } catch (err) {
      console.error('Error al consultar sedes:', err);
      // Detectar error de timeout o conexión
      // Si hay un error, mostramos el componente de servicio no disponible
      setServicioNoDisponible(true);
      setErrorSedes(''); // Limpiamos el error de texto para mostrar solo el componente gráfico
      setSedes([]);
    } finally {
      setCargandoSedes(false);
    }
  };

  const buscarSedesDireccion = async (sedesDisp) => {
    setErrorSedes('');
    setSedes([]);
    try {
      const empresasCsv = toEmpresaCsv(empresaNombre);

      // Consultar por cada sede disponible su dirección y empresa via nuevo endpoint
      const solicitudes = sedesDisp.map(async (p) => {
        const payload = { oid_sede: p.oid_sede, empresa: empresasCsv };
        const resp = await viewSedePorOidEmpresaApi(payload);
        const registro = resp?.result && resp.result.length > 0 ? resp.result[0] : null;

        return {
          // Mantener compatibilidad con la UI
          oid: p.oid_sede,
          id: registro?.id || null,
          nombre_sede: registro?.nombre_sede || p.nombre_sede || '',
          direccion: registro?.direccion || '',
          // Agregar nuevos campos solicitados y mantener nombre_empresa para compatibilidad
          empresa: registro?.nombre_empresa || '',
          nombre_empresa: registro?.nombre_empresa || ''
        };
      });

      const sedesEnriquecidas = await Promise.all(solicitudes);
      console.log('Sedes Enriquecidas:', sedesEnriquecidas);
      setSedes(sedesEnriquecidas);
      setVerBusqueda(1);
      setCargandoSedes(false);
    } catch (err) {
      setErrorSedes('Error al consultar las sedes: ' + err.message);
      setSedes([]);
    } finally {
      // noop
    }
  };

  const seleccionarSede = async (sede) => {
    setSedeSeleccionada(sede.oid);
    setSedeId(sede.id || null);
    setEmpresaSeleccionada(sede.nombre_empresa || sede.nombre_empresa_especialidad || '');
    setSedeNombre(sede.nombre_sede);
    // Nuevo: almacenar id real de oficina_sede para citas extra
    setCita(prev => ({
      ...prev,
      sedeIdOficina: sede.id || null
    }));
  };

  const continuarFechas = () => {
    if (!sedeSeleccionada) {
      setErrorSedes('Por favor seleccione una sede');
      return;
    }
    setCita(prev => ({
      ...prev,
      ciudadId,
      ciudadNombre,
      especialidadNombre,
      nombreServicio,
      descripcion,
      oidEspecialidad,
      empresaSeleccionada,
      sedeId: sedeSeleccionada,
      sedeIdOficina: sedeId,
      sedeNombre,
      empresaArray: empresaNombre,
      valorPreviplan,
      sku,
    }));
    navigate('/fechas');
  };

  return (
    <div id="cajaPrincipal"
      style={cajaPrincipalStyle}
    >
      <Titulo titulo="Elige tu sede"
        subtitulo="Selecciona la sede disponible donde deseas recibir la atención del servicio."
        imagen_titulo="ubica"
        rutaRetorno="/servicios"
        stateRetorno={{
          ciudadId: ciudadId,
          ciudadNombre: ciudadNombre,
        }}
      ></Titulo>
      <LoadingOverlay visible={cargando || cargandoSedes || validandoAcceso} />

      {/* Div central */}
      <div style={{...cajaContenedorStyle, ...(isMobile && { marginLeft: '0', width: '100%', padding: '0 2vh', boxSizing: 'border-box' })}}>
        {/* Primer div */}

        {/* Contenido del primer div */}
        <div style={{...cajaContenedorPrimeroStyle, ...(isMobile && { width: '100%', marginLeft: '0', display: 'flex', flexDirection: 'column', alignItems: 'center' })}}>
          {/* Lista de sedes */}
          <div style={{
            marginTop: '3vh',
            marginLeft: '0vh',
            width: isMobile ? '100%' : '69.5vh',
            maxHeight: '52vh',
            overflowY: 'auto',
            paddingBottom: '1vh'
          }}>
            {cargandoSedes && (
              <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                height: '20vh',
                width: '100%',
                gap: '1vh'
              }}>
                 <span style={{
                    fontSize: '2.2vh',
                    fontFamily: 'Inter',
                    fontWeight: '600',
                    color: colors.primaryText,
                    textAlign: 'center'
                  }}>
                  Cargando sedes...
                </span>
                <span style={{
                    fontSize: '1.4vh',
                    fontFamily: 'Inter',
                    color: colors.gray600,
                    textAlign: 'center'
                  }}>
                  Por favor espere un momento
                </span>
              </div>
            )}

            {servicioNoDisponible && (
              <ServicioNoDisponible mensaje="Lo sentimos, el servicio de consulta de sedes no está disponible en este momento. Por favor intente más tarde." />
            )}

            {!servicioNoDisponible && sedes.length > 0 && (
              <ul style={{
                listStyle: 'none',
                padding: '1.5vh',
                margin: 0,
                gap: '0.55vh',
                display: 'flex',
                flexDirection: 'column',
                backgroundColor: '#EFEFEF',
                borderRadius: '1vh',
              }}>
                {sedes.map((sede, index) => (
                  <li
                    key={index}
                    onClick={() => seleccionarSede(sede)}
                    style={{
                      width: '100%',
                      height: 'auto',
                      minHeight: '6.2vh',
                      transform: 'rotate(0deg)',
                      padding: '0.75vh 1.4vh',
                      opacity: 1,
                      borderRadius: '1.0vh',
                      borderWidth: '0.1vh',
                      borderStyle: 'solid',
                      borderColor: '#E0E0E0',
                      backgroundColor: sedeSeleccionada === sede.oid ? '#ACF1F9' : '#FFFFFF',
                      display: 'flex',
                      alignItems: 'center',
                      fontSize: '1.55vh',
                      fontFamily: 'Inter',
                      color: '#0C6B63',
                      cursor: 'pointer',
                      transition: 'all 0.3s ease',
                      boxSizing: 'border-box'
                    }}
                  >
                    <div style={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '0.15vh',
                      minWidth: 0,
                      flex: 1,
                    }}>
                      <div style={{
                        fontWeight: 'bold',
                        fontSize: '1.65vh',
                        lineHeight: 1.15,
                        color: sedeSeleccionada === sede.oid ? '#333' : '#333'
                      }}>
                        {`${sede.nombre_sede || 'Sede sin nombre'}`}
                      </div>
                      <div style={{
                        fontSize: '1.28vh',
                        lineHeight: 1.2,
                        color: '#0C6B63'
                      }}>
                        {sede.direccion || ''}
                      </div>
                    </div>

                    <div style={{
                      marginLeft: 'auto',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: '#28a745',
                      fontSize: '2.2vh',
                      width: '3vh',
                      height: '100%'
                    }}>
                      <img 
                        src={sedeSeleccionada === sede.oid ? '/ok4.png' : '/ok2.png'} 
                        alt={sedeSeleccionada === sede.oid ? 'Seleccionado' : 'No seleccionado'} 
                        style={{ width: '3vh', height: '3vh' }} 
                      />
                    </div>
                  </li>
                ))}
              </ul>
            )}
            {/* Advertencia de no resultados */}
            {verBusqueda > 0 && !errorSedes && !servicioNoDisponible && sedes.length === 0 && (
              <Advertencia mensaje={advertenciaMensaje || "No se encontraron resultados para tu búsqueda."} ancho="60vh" />
            )}
          </div>
          <div id="cajaSiguiente" style={{
            display: 'flex',
            flexDirection: 'column',
            width: isMobile ? '100%' : '80vh',
            marginTop: '1vh',
            gap: '2vh',
            justifyContent: isMobile ? 'center' : 'flex-end',
            alignItems: isMobile ? 'center' : 'flex-end',
            position: 'relative',
          }}>
            <Boton
              label={cargandoSedes ? "Enviando..." : "Continuar"}
              onClick={continuarFechas}
              siguiente
              ancho={isMobile ? '100%' : '23vh'}
              alto="5.2vh"
              disabled={cargandoSedes || validandoAcceso || !sedeSeleccionada}
            />
          </div>
        </div>
        {/* Fin contenido del primer div */}

        {!isMobile && <Resumen ciudad={ciudadNombre} servicio={especialidadNombre} nomServicio={nombreServicio} descripcion={descripcion} />}
      </div>
      {errorSedes && (
        <div style={{
          color: 'red',
          fontSize: '1.6vh',
          fontFamily: 'Inter'
        }}>
          {errorSedes}
        </div>
      )}

    </div>
  );
}

export default Ubicacion;
